import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { TYPE_POLL } from 'app/constants/messageType'

const PRIMARY = 'primary'
const SECONDDARY = 'secondary'
const WARNING = 'warning'
const ERROR = 'error'
const INFO = 'info'

const renderBadge = (theme, variant) => {
  switch (variant) {
    case PRIMARY:
      return theme.palette.primary.main350
    case SECONDDARY:
      return theme.palette.secondary.main
    case WARNING:
      return theme.palette.warning.main
    case ERROR:
      return theme.palette.error.main
    case INFO:
      return '#0EA5E9'
    default:
      break
  }
}

const getLabelColor = (theme, variant) => {
  switch (variant) {
    case PRIMARY:
      return theme.palette.primary.main300
    case SECONDDARY:
      return theme.palette.primary.main300
    case WARNING:
      return theme.palette.primary.main300
    case ERROR:
      return theme.palette.primary.contrastText
    case INFO:
      return '#ffffff'
    default:
      break
  }
}

const useStyles = makeStyles((theme) => ({
  label: ({ variant }) => ({
    color: getLabelColor(theme, variant),
    fontSize: '10px',
  }),
  button: ({ variant }) => ({
    backgroundColor: renderBadge(theme, variant),
    borderRadius: 4,
  }),
}))

const MessageBadge = ({
  className,
  variant = 'primary',
  isTextUpperCase = true,
  children,
  type,
}) => {
  const classes = useStyles({ variant })
  return (
    <span
      className={clsx(
        classes.button,
        'flex h-20 items-center text-center cursor-default p-2',
        className,
      )}
    >
      <Typography
        className={clsx(
          classes.label,
          isTextUpperCase ? 'uppercase' : undefined,
        )}
      >
        {children}
      </Typography>
    </span>
  )
}

export default MessageBadge
